var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.tableData.length
    ? _c("div", { staticClass: "spu-list-container-content" }, [
        _c("div", { staticClass: "store-info" }, [
          _c("span", [
            _vm._v(
              _vm._s(
                _vm.detail && _vm.detail.role && _vm.detail.role.name
                  ? _vm.detail.role.name
                  : ""
              )
            ),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "spu-list" },
          [
            _vm.showRefundDescription
              ? _c("div", { staticClass: "spu-refund-desc" }, [
                  _vm._v(" 訂單已扣除欠品與退貨品項重新計算最優惠活動 "),
                ])
              : _vm._e(),
            _vm._l(_vm.tableData, function (group, index) {
              return _c(
                "div",
                { key: group.key, staticClass: "container-spu-item" },
                [
                  _c("div", { staticClass: "top-promotion" }, [
                    _c("div", { staticClass: "left-promotion flex-center" }, [
                      group.promotion && group.promotion.title
                        ? _c(
                            "div",
                            { staticClass: "promotion-tag flex-center origin" },
                            [_vm._v("特價")]
                          )
                        : _c(
                            "div",
                            { staticClass: "promotion-tag flex-center blue" },
                            [_vm._v("普通商品")]
                          ),
                      group.promotion && group.promotion.title
                        ? _c("span", [_vm._v(_vm._s(group.promotion.title))])
                        : _vm._e(),
                    ]),
                  ]),
                  _vm._l(group.orderItemList, function (item, itemIndex) {
                    return _c("order-detail-spu-list-item", {
                      key: item.id || itemIndex,
                      attrs: { "item-data": item, detail: _vm.detail },
                    })
                  }),
                  group.promotionPrice
                    ? _c("div", { staticClass: "promotion-price" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("小計："),
                        ]),
                        _c("span", [
                          _vm._v("NT$ " + _vm._s(group.promotionPrice)),
                        ]),
                      ])
                    : _vm._e(),
                  group.promotion &&
                  group.promotion.title &&
                  _vm.tableData.length >= 2 &&
                  index < _vm.tableData.length - 1
                    ? _c("div", { staticClass: "diviser-line" })
                    : _vm._e(),
                ],
                2
              )
            }),
          ],
          2
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }